import { useRef } from "react";
export function useRefAndForward(initialValue, forwardedRef) {
    var ref = useRef(initialValue);
    var forward = function (instance) {
        ref.current = instance;
        if (typeof forwardedRef === "function") {
            forwardedRef(instance);
        }
        else if (forwardedRef) {
            forwardedRef.current = instance; // eslint-disable-line no-param-reassign
        }
    };
    return [ref, forward];
}
//# sourceMappingURL=use-ref-and-forward.js.map